import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import ConversationsIcon from '../../Conversations/ConversationsIcon/ConversationsIcon';
import { truncateText } from '../../../helpers/utils';
import { SET_DETAILS_TAB } from '../../../redux/OffersDetails';
import { CONTACT_TAB, CONVERSATIONS_TAB, DETAILS_TAB } from '../../../consts/detailsTabs';
import { SET_SEEN_BY_DEALER } from '../../../redux/Conversations';
import { ACCEPTED, navigationMapping } from '../../../consts/navigation';
import { compose } from 'redux';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

class BreadcrumbsOfferDetails extends PureComponent {
  switchTab = (e) => {
    const { setDetailsTab, conversationId, setSeenByDealer, isConversationBold } = this.props;
    const tabName = e.target.getAttribute('name');
    if (tabName === CONVERSATIONS_TAB && isConversationBold) {
      setSeenByDealer(conversationId);
    }
    setDetailsTab({ tabName });
  }

  renderNavigationLink = (tabName, label) => {
    const { detailsActiveTab } = this.props;
    const linkClasses = classNames('nav-link', { active: detailsActiveTab === tabName });
    return <a className={linkClasses} name={tabName} onClick={this.switchTab}>{label}</a>;
  }

  render() {
    const {
      model,
      name,
      shouldShowContactDetails,
      isConversationBold,
      whichFolder,
      t,
    } = this.props;
    const displayedText = name && `${name} ${model}`;
    const formattedDisplayedText = truncateText(displayedText, 25, 'bottom');
    const conversationsCountSymbol = (isConversationBold ? '!' : '');
    return (
      <div className="main-area__header">
        <div className="row">
          {navigationMapping[whichFolder] &&
            (<>
              <div className="col-md-7 breadcrumbs">
                <Link to={navigationMapping[whichFolder].table_url}>{t(whichFolder)}</Link>
                <i className="material-icons u-font-size--20">keyboard_arrow_right</i>
                {formattedDisplayedText}
              </div>
              <div className="col-md-5 details__menu">
                <ul>
                  {shouldShowContactDetails && this.renderNavigationLink(CONTACT_TAB, t('contact'))}
                  {this.renderNavigationLink(DETAILS_TAB, t('details'))}
                  {this.renderNavigationLink(CONVERSATIONS_TAB, t('conversations'))}
                </ul>
                {conversationsCountSymbol && <ConversationsIcon count={conversationsCountSymbol} />}
              </div>
            </>)
          }

        </div>
      </div>
    );
  }
}

BreadcrumbsOfferDetails.propTypes = {
  t: PropTypes.func.isRequired,
  model: PropTypes.string.isRequired,
  setDetailsTab: PropTypes.func.isRequired,
  setSeenByDealer: PropTypes.func.isRequired,
  conversationId: PropTypes.number,
  detailsActiveTab: PropTypes.string,
  shouldShowContactDetails: PropTypes.bool,
  name: PropTypes.string,
  isConversationBold: PropTypes.bool,
  whichFolder: PropTypes.string,
};

BreadcrumbsOfferDetails.defaultProps = {
  name: '',
  detailsActiveTab: null,
  shouldShowContactDetails: null,
  isConversationBold: null,
  conversationId: null,
  whichFolder: null,
};

const mapStateToProps = (state, ownProps) => {
  return {
    detailsActiveTab: get(state, ['offerDetails', 'detailsActiveTab']),
    isConversationBold: get(state, ['conversations', 'conversations', ownProps.hashId, 'bold']),
    conversationId: get(state, ['conversations', 'conversations', ownProps.hashId, 'id']),
    shouldShowContactDetails: (
      !!get(state, ['offerDetails', 'data', 'details']) ||
      !!get(state, ['archive', ACCEPTED, 'data', 'details'])
    ),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDetailsTab: payload => dispatch(SET_DETAILS_TAB(payload)),
    setSeenByDealer: conversationId => dispatch(SET_SEEN_BY_DEALER({ conversationId })),
  };
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withScopedTranslations('breadcrumbs.browse_details')
)(BreadcrumbsOfferDetails);
